
export class Person  {
	id: string;
	first_name: string;
	last_name: string;
	address_1: string;
	address_2: string;
	city: string;
	state: string;
	 postal_code: string;
	 country: string;
	 phone: string;
	 birth_date: string;
	 email: string;
	 ec_number: string;
	 usef_number: string;
	 ohja_number: string;
	 stable_name: string;
	 last_modified: Date;
	 created_date: Date;
	 fei_id: string;
	 usef_person_uuid: string;
	 usef_entity_type: string;
	 use_usef_personal_details:  boolean;
	 ushja_id: string;
	 oef_number: string;

	 //Person created by an e-commerce user
	 user_id: string;

	 //Person created by an organizer in Show Management System
	 number: number;
	 competition_organizer_id: string;

	 constructor(values: Object = {}) {
		Object.assign(this, values);
	}

}
